import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../config/config";
import FrontVideo from "../components/homevideo";
import HeaderTitle from "../components/headerTitle";
import ClientExperiences from "../components/home/client-experiences";
import WhatWeOffer from "../components/CommonSections/WhatWeOffer";
import Advantage from "../components/CommonSections/Advantage";
import PageLoader from "../components/home/pageload";
import MetaTag from "../components/CommonSections/MetaTag";
import SubServiceSchema from "../components/CommonSections/subServicesSchema";
import Accordion from "../components/accordion";
import ImgSakshamAi from "../assest/images/IshanManagedCloudServices.png";

const SERVICE_TAG = "saksham_ai_infrastructure";
const PAGE_KEY = "unified_services";

/**
 * Saksham AI Infrastructure page, laid out like Enterprise Connectivity.
 * All content is managed in Admin > Sovereign AI & Cloud > Saksham AI Infrastructure.
 */
export default function SakshamAiInfrastructure() {
     const [pageData, setPageData] = useState(null);
     const [settingResponse, setSettingResponse] = useState(null);

     const handleClick = () => {
          window.scrollTo(0, 0);
     };

     useEffect(() => {
          axios.post(`${API_BASE_URL}/api/unifiedservices/getUnifiedservices`, { service_tag: SERVICE_TAG }).then((response) => {
               setPageData(response);

               const generalSettingsData = response?.data?.data?.general_settings?.general_settings_data || [];
               const serviceSettingsData = generalSettingsData.find((item) => item.tag === SERVICE_TAG) || null;
               const advantageSettingsData = generalSettingsData.find((item) => item.tag === `${SERVICE_TAG}_advantage`) || null;
               setSettingResponse({
                    ...JSON.parse(serviceSettingsData?.response || "{}"),
                    advantages: advantageSettingsData ? JSON.parse(advantageSettingsData.response || "{}") : undefined,
               });
          }).catch(() => { });
     }, []);

     const services = pageData?.data?.data?.unified_services;
     const banner = services?.unified_services_banner_data?.[0];
     const ctaBanner = services?.unified_services_cta_banner_data?.[0];

     const getFaqSchema = () => {
          const faqData = services?.faq_info_data || [];
          return {
               "@context": "https://schema.org",
               "@type": "FAQPage",
               mainEntity: faqData.map(faq => ({
                    "@type": "Question",
                    name: faq.question,
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: faq.answerData || faq.answer.replace(/<[^>]*>?/gm, '')
                    }
               }))
          };
     };

     if (pageData === null) {
          return <PageLoader />;
     }

     return (
          <>
               <SubServiceSchema title={banner?.title} url='https://ishantechnologies.com/saksham-ai-infrastructure' parentTitle='Sovereign AI & Cloud Services' parentUrl='https://ishantechnologies.com/sovereign-ai-and-cloud-services' />
               <MetaTag data={pageData} pageKey={PAGE_KEY} />
               <div className="page_heading responsive_heading">
                    <div className="container">
                         <HeaderTitle headerTitledata={pageData} pageKey={PAGE_KEY} />
                    </div>
               </div>
               <div className={`video hero-banner ${!banner?.banner_title && !banner?.banner_img_desc ? 'no-content' : ''}`}>
                    <FrontVideo homeData={pageData} pageKey={PAGE_KEY} />

                    <div className="banner-content ">
                         {banner?.banner_title && (
                              <h2 className='home-heading'>{banner.banner_title}</h2>
                         )}

                         {banner?.banner_img_desc && (
                              <p className="para">{banner.banner_img_desc}</p>
                         )}

                         {banner?.button_img_name && (
                              <a href={banner.button_url}>
                                   <button className="button hero-btn">{banner.button_img_name}</button>
                              </a>
                         )}
                    </div>
               </div>

               <div className="empowering section-space spin-wrap">
                    <div className="spin-round-wrap">
                         <div className="spin-round color-navy-blue">
                              <span className='ballDot1'>1</span>
                              <span className='ballDot2'>2</span>
                              <span className='ballDot3'>3</span>
                              <span className='ballDot4'>4</span>
                         </div>
                    </div>
                    <div className="container">
                         <div className="empowering-inner">
                              <div className="empowering-left">
                                   <img src={ImgSakshamAi} alt="Saksham AI Infrastructure" height={60} width={60} loading="lazy" />
                              </div>
                              <div className="empowering-right" dangerouslySetInnerHTML={{ __html: services?.unified_services_information_data?.[0]?.description }}>
                              </div>
                         </div>
                    </div>
                    <div className="spin-round-wrap">
                         <div className="spin-round">
                              <span className='ballDot1'>1</span>
                              <span className='ballDot2'>2</span>
                              <span className='ballDot3'>3</span>
                              <span className='ballDot4'>4</span>
                         </div>
                    </div>
               </div>

               <div className="weoffer-bgdark">
                    <WhatWeOffer title={settingResponse?.what_we_offer} data={services?.unified_services_offer_data} />
               </div>

               <Advantage title={settingResponse?.advantages} data={services?.unified_services_advantages_data} />

               <div className="client-experiences section-space">
                    <ClientExperiences homeData={pageData} pageKey={PAGE_KEY} tag={SERVICE_TAG} />
               </div>

               {services?.faq_info_data?.length > 0 && (
                    <div className="frequently section-space">
                         <div className="container">
                              <h2 className="supercharge-heading">Frequently Asked Questions (FAQs)</h2>

                              <script
                                   type="application/ld+json"
                                   dangerouslySetInnerHTML={{ __html: JSON.stringify(getFaqSchema()) }}
                              />

                              <Accordion items={services.faq_info_data} />
                         </div>
                    </div>
               )}

               <div className="supercharge supercharge-left">
                    <div className="container">
                         <h2 className="supercharge-heading">{ctaBanner?.title}</h2>
                         <div className="supercharge-btns">
                              {ctaBanner?.button_title_1 &&
                                   <Link to={ctaBanner.button_url_1}>
                                        <button className="getintouch" onClick={handleClick}>{ctaBanner.button_title_1.toUpperCase()}</button>
                                   </Link>
                              }
                              {ctaBanner?.button_title_2 &&
                                   <Link to={ctaBanner.button_url_2} target="_blank">
                                        <button className="getintouch" onClick={handleClick}>{ctaBanner.button_title_2.toUpperCase()}</button>
                                   </Link>
                              }
                         </div>
                    </div>
               </div>
          </>
     );
}
